<a
    class="fw:semibold c:grey-1"
    [attr.href]="'/portal/meine-vertraege/' + contract()?.id"
    (click)="handleCancel(); $event.preventDefault()"
>
    <i ctrlIcon="chevron_left"></i> <span>Zurück zur {{ product()?.title }}</span>
</a>
<ng-template appStepHost></ng-template>
